import { Toast } from "@newsela/angelou";

export const EVENT_TOAST_FAIL = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Classes sync fail",
};
